import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoEa = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 31.7798 31.7797",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.8899 31.7797C7.1281 31.7797 0 24.6515 0 15.8899C0 7.12812 7.1281 0 15.8899 0C24.6514 0 31.7798 7.12816 31.7798 15.8899C31.7798 24.6515 24.6516 31.7797 15.8899 31.7797ZM18.5793 9.74382H9.59919L8.23665 11.9335H17.2065L18.5793 9.74382ZM20.4146 9.76471L14.9248 18.5061H8.83533L10.2402 16.3146H13.8899L15.2842 14.1242H6.84658L5.45269 16.3146H7.45151L4.67824 20.69H16.252L20.5269 13.9484L22.0855 16.3146H20.6801L19.3492 18.5061H23.511L24.9563 20.69H27.6111L20.4146 9.76471Z",
		fill: "var(--fill-0, #FAF5F5)",
		fillOpacity: .45
	})]
});
const ForwardRef = forwardRef(SvgLogoEa);
export { ForwardRef as ReactComponent };
